import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const index = resolve => require(['../views/index/index'], resolve)
const course = resolve => require(['../views/course/course'], resolve)
const serve = resolve => require(['../views/serve/serve'], resolve)
const insert = resolve => require(['../views/insert/insert'], resolve)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: index,
    },
    {
      path: '/serve',
      name: '服务',
      component: serve
    },
    {
      path: '/course',
      name: '课程',
      component: course
    },
    {
      path: '/insert',
      name: '课程',
      component: insert
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js